import { useModel } from "@type-r/react";
import React from "react";
import { AssetType } from "../../api/assetType";
import { UnappliedCash, UnappliedCashCount, UnappliedCashData } from "../../api/unappliedCash";
import { ConfirmAssetsDataStep } from "../confirm-assets-data-step";
import { UnappliedCashExternalSystems } from "./externalSystems";
import { UnappliedCashForm } from "./unapplied-cash-form";
import { UnappliedCashTableColumns } from "./unapplied-cash-table-columns";
import { UnappliedCasheQuerry } from "./unapplied-cashes-querry";

export const ConfirmUnappliedCashesDataStep = ({ isEdit, job, next, cancel, startOver, $assetTypeSelect, assetTypeMultiOptions, $refreshEvents }:
    { isEdit: boolean, job, next?, cancel?, startOver?, $assetTypeSelect?, assetTypeMultiOptions?, $refreshEvents?}) => {
    const unappliedCashChanges = useModel(UnappliedCashData);
    const unappliedCashCountModel = useModel(UnappliedCashCount);
    const unappliedCashQuerryModel = useModel(UnappliedCasheQuerry);

    return <>
        <ConfirmAssetsDataStep
            isEdit={isEdit}
            job={job}
            assetName="Unapplied Cash"
            assetType={AssetType.unappliedCash}
            assetModel={UnappliedCash}
            countModel={unappliedCashCountModel}
            queryModel={unappliedCashQuerryModel}
            tableColumns={UnappliedCashTableColumns}
            assetChanges={unappliedCashChanges}
            next={next} cancel={cancel} startOver={startOver}
            externalSystems={UnappliedCashExternalSystems}
            assetForm={unappliedCash => <UnappliedCashForm unappliedCash={unappliedCash} />}
            $assetTypeSelect={$assetTypeSelect}
            assetTypeMultiOptions={assetTypeMultiOptions}
            $refreshEvents={$refreshEvents}
        />
    </>
}


